import React, { useContext, useEffect } from 'react'
import Newsdetailssection from '../../organisms/NewsDetailssections/Newsdetailssection'
import Footer from '../../organisms/Footersections/Footer'
import { AppContext } from '../../../services/Appcontext'
import { useLocation, useParams } from 'react-router-dom'

export default function Newsdetails() {
  const {newsById, getNewsById} = useContext(AppContext)
  const { id } = useParams(); // Extract the 'id' from the route path
  // console.log("this is the id",id)


  useEffect(()=>{
    getNewsById(id)
  },[])
  
  // console.log("this is the data about the news", newsById)

  return (
    <div className="flex flex-col min-h-screen">
      <div className="flex-grow">
        {!newsById.loading && (
          <Newsdetailssection data={newsById.data} />
        )}
      </div>
      <Footer />
    </div>
  )
}
